// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ho-0";
export var actionModalContentContainer = "_ho-1";
export var createTagButton = "_ho-2";
export var footerContainer = "_ho-7";
export var fullWidthDivider = "_ho-3";
export var hasCreateTagButton = "_ho-4";
export var noCreateTagButton = "_ho-5";
export var tagsContainer = "_ho-6";
export var tagsModalContentContainer = "_ho-8";